import { Expression } from './Expression.js';
import { OclExecutionContext } from '../OclExecutionContext.js';

export class StaticOperationDefExpression extends Expression {
  //@ts-ignore
  constructor(
    // public typeName: string,
    public name: string,
    public paramNames: Array<string>,
    public inContextDef: Expression
  ) {
    super();
  }

  evaluate(visitor: OclExecutionContext, localVariables?: any): any {
    const typeName = visitor.getTargetTypeName();
    visitor.enrichStatic(typeName, this.name, (...params: any[]) => {
      let operationParams: any = {};
      if (this.paramNames) {
        this.paramNames.forEach((v, i) => operationParams[v] = params[i]);
      }

      const locals = {...localVariables, ...operationParams };
      return this.inContextDef.evaluate(visitor, locals);
    });
  }
}
